import React, { memo } from "react";
import { HEADER_LOTTIE_ASSETS, LottieAnimation } from "@swiggy-private/core-ui";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import { BoltStampLottieFinalStateFrames, BoltStampLottieFrames, lottieProps } from "./constants";

interface IStampLottieProps {
    handleError: () => void;
    onPlayComplete: () => void;
    showBoltLottie: boolean;
    showFinalState: boolean;
}

const BoltOtgStampLottie = memo(
    ({ handleError, onPlayComplete, showBoltLottie, showFinalState }: IStampLottieProps) => {
        return (
            <LottieAnimation
                {...lottieProps}
                fileName={getCloudinaryUrl(HEADER_LOTTIE_ASSETS.BOLT_OTG_STAMP) || ""}
                visible={showBoltLottie}
                playLottie={showBoltLottie}
                autoplay={showBoltLottie}
                onError={handleError}
                frame={showFinalState ? BoltStampLottieFinalStateFrames : BoltStampLottieFrames}
                onPlayComplete={onPlayComplete}
            />
        );
    },
);

const BoltSla10StampLottie = memo(
    ({ handleError, onPlayComplete, showBoltLottie, showFinalState }: IStampLottieProps) => {
        return (
            <LottieAnimation
                {...lottieProps}
                fileName={getCloudinaryUrl(HEADER_LOTTIE_ASSETS.BOLT_SLA_10_STAMP) || ""}
                visible={showBoltLottie}
                playLottie={showBoltLottie}
                autoplay={showBoltLottie}
                onError={handleError}
                frame={showFinalState ? BoltStampLottieFinalStateFrames : BoltStampLottieFrames}
                onPlayComplete={onPlayComplete}
            />
        );
    },
);

const BoltSla15StampLottie = memo(
    ({ handleError, onPlayComplete, showBoltLottie, showFinalState }: IStampLottieProps) => {
        return (
            <LottieAnimation
                {...lottieProps}
                fileName={getCloudinaryUrl(HEADER_LOTTIE_ASSETS.BOLT_SLA_15_STAMP) || ""}
                visible={showBoltLottie}
                playLottie={showBoltLottie}
                autoplay={showBoltLottie}
                onError={handleError}
                frame={showFinalState ? BoltStampLottieFinalStateFrames : BoltStampLottieFrames}
                onPlayComplete={onPlayComplete}
            />
        );
    },
);

const BoltRangeSlaStampLottie = memo(
    ({ handleError, onPlayComplete, showBoltLottie, showFinalState }: IStampLottieProps) => {
        return (
            <LottieAnimation
                {...lottieProps}
                fileName={getCloudinaryUrl(HEADER_LOTTIE_ASSETS.BOLT_RANGE_SLA_STAMP) || ""}
                visible={showBoltLottie}
                playLottie={showBoltLottie}
                autoplay={showBoltLottie}
                onError={handleError}
                frame={showFinalState ? BoltStampLottieFinalStateFrames : BoltStampLottieFrames}
                onPlayComplete={onPlayComplete}
            />
        );
    },
);

export { BoltOtgStampLottie, BoltSla10StampLottie, BoltSla15StampLottie, BoltRangeSlaStampLottie };
